export const Features = (props) => {
  return (
    <div id='features' className='text-center'>
    <title>We provide istallation,uninstallation,repair and servicing of all kinds of ro water purifier</title>
    <meta name="description" content="We provide istallation,uninstallation,repair and servicing of all kinds of ro water purifier."></meta>
      <div className='container'>
        <div className='col-md-10 col-md-offset-1 section-title'>
          <h2>We Provide</h2>
        </div>
        <div className='row'>
          {props.data
            ? props.data.map((d, i) => (
                <div key={`${d.title}-${i}`} className='col-xs-6 col-md-3'>
                  {' '}
                  <i className={d.icon}></i>
                  <h3>{d.title}</h3>
                  <p>{d.text}</p>
                </div>
              ))
            : 'Loading...'}
        </div>
      </div>
    </div>
  )
}
